"use client";

import Link from "next/link";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useAppliedJobs } from "@/lib/use-applied-jobs";
import { useLanguage } from "@/lib/i18n/LanguageContext";

export function ApplyAction({
  jobId,
  label,
  wrapperClassName,
  buttonClassName,
  appliedBadgeClassName,
  skeletonClassName,
}: {
  jobId: string;
  label: string;
  wrapperClassName?: string;
  buttonClassName: string;
  appliedBadgeClassName: string;
  skeletonClassName: string;
}) {
  const { appliedIds, checking } = useAppliedJobs();
  const { t } = useLanguage();

  if (checking) {
    return (
      <span
        className={`inline-block animate-pulse rounded-xl bg-muted ${skeletonClassName} ${wrapperClassName ?? ""}`}
        aria-hidden
      />
    );
  }

  if (appliedIds.has(jobId)) {
    return (
      <div className={`flex flex-col items-center gap-1.5 ${wrapperClassName ?? ""}`}>
        <span className={appliedBadgeClassName}>
          <CheckCircle2 className="h-4 w-4" aria-hidden /> {t.home.alreadyApplied}
        </span>
        <Link href="/profile#applications" className="text-xs font-semibold text-primary hover:underline">
          {t.apply.viewProfileBtn}
        </Link>
      </div>
    );
  }

  return (
    <Link href={`/jobs/${jobId}/apply`} className={`${buttonClassName} ${wrapperClassName ?? ""}`}>
      {label} <ArrowRight className="h-4 w-4" />
    </Link>
  );
}
